import { getRecord, cancelIntercept, setRead } from '@/services/smart'

const store = {
  namespaced: true,
  state: {
    loading: false,
    totalCount: 0,
    interceptList: [],
    pagination: {
      currentPage: 1,
      pageSize: 10,
      pageSizes: [10, 20, 30, 50],
      pageSizesType: { 10: 1, 20: 2, 30: 3, 50: 4 },
      total: 0
    }
  },
  mutations: {
    SET_TOTAL_COUNT (state, count) {
      state.totalCount = count
    },
    SET_INTERCEPT_LIST (state, list) {
      state.interceptList = list
    },
    SET_PAGINATION (state, params) {
      const { key, value } = params
      state.pagination = Object.assign(state.pagination, { [key]: value })
    },
    SET_LOADING (state, load) {
      state.loading = load
    },
    SET_LIST_READ (state, data) {
      const { index, params } = data
      if (index !== -1) {
        state.interceptList[index]['isRead'] = true
      } else {
        let ids = params.ids.split(',')
        let count = 0
        for (let i = 0; i < ids.length; i++) {
          let item = Number(ids[i])
          for (let k = 0; k < state.interceptList.length; k++) {
            if (count === ids.length) {
              break
            }
            let intercept = state.interceptList[k]
            if (item === intercept.id) {
              count++
              intercept.isRead = true
            }
          }
        }
      }
    }
  },
  actions: {
    // 获取拦截记录数据列表
    async fetchDataList ({ commit }, params) {
      commit('SET_LOADING', true)
      const chain = await getRecord()
        .params({ scope: 2, ...params })
        .onSuccess(res => {
          const { count, list } = res
          commit('SET_TOTAL_COUNT', count)
          commit('SET_INTERCEPT_LIST', list)
          commit('SET_PAGINATION', { key: 'total', value: Number(count) })
        })
        .onNetComplete(() => {
          commit('SET_LOADING', false)
        })
        .fetch()
      return chain
    },
    // 标记已读
    async toMarkRead ({ commit }, params) {
      const chain = await setRead()
        .params(params)
      return chain
    },
    // 取消拦截
    async cancelInterceptStatus ({ commit }, params) {
      const chain = await cancelIntercept()
        .params(params)
        .config({ tip: false })
      return chain
    }
  }
}

export default store
